export enum ADDRESS_MODAL_TRANSITIONS {
  OPEN = 'OPEN',
  CLOSE = 'CLOSE',
  SUBMIT = 'SUBMIT',
}
